import { render, staticRenderFns } from "./cheat-manage.vue?vue&type=template&id=5c67618e&scoped=true&"
import script from "./cheat-manage.vue?vue&type=script&lang=js&"
export * from "./cheat-manage.vue?vue&type=script&lang=js&"
import style0 from "./cheat-manage.vue?vue&type=style&index=0&id=5c67618e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c67618e",
  null
  
)

export default component.exports